module.exports = __webpack_public_path__ + "static/img/douyin.7c3bc84c.png";